import {
  MenuItem,
  TextField,
  type TextFieldProps,
  useTheme,
} from '@mui/material';
import { type ThemeMode, themes } from '#/theme';
import { cn, styleVars } from '#/utils/styles';

export interface ThemeSwitchProps extends Omit<TextFieldProps, 'onChange'> {
  /**
   * The function to call when the theme changes.
   */
  onChange: (theme: ThemeMode) => void;
}

function ThemeSwitch({
  onChange,
  label = 'Theme',
  ...props
}: ThemeSwitchProps) {
  const theme = useTheme();
  return (
    <TextField
      {...props}
      select
      label={label}
      value={theme.palette.mode}
      onChange={(e) => onChange(e.target.value as ThemeMode)}
    >
      {themes.map((theme) => (
        <MenuItem key={theme.name} value={theme.name}>
          <div className='flex items-center gap-2'>
            <div
              className={cn(
                'flex items-center gap-2 py-1 px-2 rounded-md',
                'bg-(--example-background)',
                'text-(--example-text)',
                'border border-(--example-border)'
              )}
              style={styleVars({
                '--example-text': theme.example.text,
                '--example-background': theme.example.background,
                '--example-border': theme.example.border,
              })}
            >
              <span
                className='rounded-full size-2 bg-(--example-primary)'
                style={styleVars({
                  '--example-primary': theme.example.primary,
                })}
              />
              <span className='text-xs'>Aa</span>
            </div>
            {theme.displayName}
          </div>
        </MenuItem>
      ))}
    </TextField>
  );
}

export default ThemeSwitch;
